<template>
  <el-dialog
    title="关联视频"
    :visible.sync="visible"
    width="660px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-transfer
      v-model="info.trainingVideoIds"
      filterable
      :filter-method="filterMethod"
      filter-placeholder="请输入视频名称"
      :titles="['未关联', '已关联']"
      :data="list"
      :props="{
        key: 'trainingVideoId',
        label: 'videoName',
      }"
    ></el-transfer>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        更新
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'GroupVideoModal',
  components: { },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 1000,
        trainingType: 1
      },
      list: [],
      info: {
        groupId: null,
        groupName: '',
        trainingVideoIds: []
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.info = {
        groupId: null,
        groupName: ''
      }
    },
    handleSubmit() {
      this.loading = true
      const dispatch = this.info.groupId
        ? 'updatetrainingvideogroup'
        : 'addtrainingvideogroup'
      this.$store.dispatch(`account/${dispatch}`, {
        payload: {
          ...this.info
        },
        success: () => {
          this.loading = false
          this.toggleModal(false)
          this.callback && this.callback()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getlist(cb) {
      this.loading = true
      this.$store.dispatch('account/gettrainingvideos', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.list = res.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    filterMethod(query, item) {
      return item.videoName.indexOf(query) > -1
    },
    update(options = {}) {
      this.getlist(() => {
        this.info = {
          ...this.info,
          ...options
        }
        this.toggleModal(true)
      })
    }
  }
}
</script>
